var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-nav-bar',{attrs:{"title":"基金说明","left-text":"返回","left-arrow":""},on:{"click-left":function($event){return _vm.$router.push('/member/stable_coinbao')}}}),_vm._v(" "),_c('div',{staticClass:"tableDetails"},[_c('van-row',[_c('p',{domProps:{"innerHTML":_vm._s(_vm.stablebao_funding_description)}})])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21639326","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/StablebaoFundingDescription.vue
// module id = null
// module chunks = 